module.exports = __webpack_public_path__ + "static/b7c915.jpg";